import request from '@/utils/request';

// 获取我的会话列表
export const GetMyConversationList = (params) => {
    return request({
        url: '/api/message/getMyConversationList',
        method: 'get',
        params
    });
};

// 发送消息
export const SendMessage = (data) => {
    return request({
        url: '/api/message/sendMessage',
        method: 'post',
        data
    });
};

// 获取我的消息列表
export const GetMyMessageList = (params) => {
    return request({
        url: '/api/message/getMyMessageList',
        method: 'get',
        params
    });
};

// 查找或创建会话   
export const FindOrCreateConversation = (data) => {
    return request({
        url: '/api/message/findOrCreateConversation',
        method: 'post',
        data
    });
};

// 获取未读消息数
export const GetUnreadMessageCount = () => {
    return request({
        url: '/api/message/getUnreadMessageCount',
        method: 'get'
    });
};